// Markup from design/kit/components/Toast: a dark message at the bottom center, past tense, with
// an action link (bb-link) when there is something to do with it (Undo, Open).
import { useEffect, useState } from 'react';

const SHOWN_MS = 5000;

type ToastProps = {
  text: string;
  action?: { label: string; onClick: () => void };
  /** How long it stays, in milliseconds. */
  shownMs?: number;
};

export function Toast({ text, action, shownMs = SHOWN_MS }: ToastProps) {
  const [shown, setShown] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setShown(false), shownMs);
    return () => clearTimeout(t);
  }, [shownMs]);
  if (!shown) return null;
  return (
    <div className="toast" role="status">
      <span>{text}</span>
      {action && (
        <button
          type="button"
          className="bb-link"
          onClick={() => {
            setShown(false);
            action.onClick();
          }}
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
